module.exports = __webpack_public_path__ + "media/assets/images/card_x-8cf57d6954c502171c94df31057f7df1.png";